import { Box } from '@mui/material';
import { KanbanColorPicker } from '../../config/KanbanColor';
import { ButtonUI, DialogUI } from '.';
import appService from '../../service/app.service';

const ColorDialogUI = ({ open, handleClose, data, refetchData }) => {
  const handleChangeColor = (color) => {
    const body = {
      subMenuUrl: data.subMenuUrl,
      lineId: data.lineId,
      color,
      type: data.type,
    };
    appService.updateColorLink(body).then(() => {
      refetchData(data.id, color);
      handleClose();
    });
  };

  const handleDeleteColor = () => {
    appService.deleteColorLink(data.subMenuUrl, data.lineId, data.type).then(() => {
      refetchData(data.id, null);
      handleClose();
    });
  };

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Szín megadása"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '450px',
          },
        },
      }}
    >
      <Box mt="1rem" display="flex" flexWrap="wrap" gap="0.3rem" justifyContent="center">
        {KanbanColorPicker.map((item) => (
          <Box
            height="40px"
            width="40px"
            borderRadius="50%"
            border="2px solid lightgrey"
            sx={{
              cursor: 'pointer',
            }}
            backgroundColor={item}
            onClick={() => handleChangeColor(item)}
          />
        ))}
        <ButtonUI text="Szín törlése" className="bg-warning mt-3 -mb-4" onClick={() => handleDeleteColor()} />
      </Box>
    </DialogUI>
  );
};

export default ColorDialogUI;
